import { ref, onMounted, onBeforeUnmount } from "vue";

export function useScrollReveal(options = {}) {
  const { threshold = 0.15, rootMargin = "0px 0px -60px 0px" } = options;
  const observedElements = ref([]);

  let observer = null;

  const observe = (el) => {
    if (el && observer) {
      observer.observe(el);
      observedElements.value.push(el);
    }
  };

  onMounted(() => {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin }
    );

    document.querySelectorAll(".reveal, .progress-item__fill").forEach((el) => {
      observer.observe(el);
    });
  });

  onBeforeUnmount(() => {
    if (observer) observer.disconnect();
  });

  return { observe };
}
